
import {Txn} from './types';

export const tailMatch = (l: Txn[], t: Txn[], full?: boolean): boolean => {
	if (full) {
		if (l.length !== t.length) {
			return false;
		}
	} else if (l.length < t.length) {
		return false;
	}

	// Check from tail
	for (let i = 0; i < t.length; i++) {
		const li = l.length - i - 1;
		const ti = t.length - i - 1;

		if (l[li].id !== t[ti].id) {
			return false;
		}
	}

	return true;
};
